import { useEffect, useRef, useState } from "react";
import BulkUploadForm from "./BulkUploadForm";

export default function BulkUploadModal({
  open,
  onClose,
  onSaved,
  tenantContext,
  currentSongCount,
  songLimit,
  onLimitReached,
}) {
  const formRef = useRef(null);
  const [readyCount, setReadyCount] = useState(0);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="bg-surface border border-border rounded-xl shadow-xl p-6 w-full max-w-4xl">
        <h2 className="text-xl font-semibold mb-4">Add Songs</h2>

        <BulkUploadForm
          ref={formRef}
          mode="full"
          tenantContext={tenantContext}
          onSaved={onSaved}
          currentSongCount={currentSongCount}
          songLimit={songLimit}
          onLimitReached={() => {
            onClose();
            onLimitReached();
          }}
          onClose={onClose}
          onReadyCountChange={(count, saving) => {
            setReadyCount(count);
            setIsSaving(saving);
          }}
        />

        {/* Footer */}
        <div className="flex justify-end gap-3 mt-5">
          <button
            onClick={onClose}
            disabled={isSaving}
            className="text-sm px-4 py-2 rounded-lg border border-border hover:bg-surface-hover disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={() => formRef.current?.save()}
            disabled={readyCount === 0 || isSaving}
            className="text-sm px-4 py-2 rounded-lg bg-accent text-white border-transparent hover:bg-accent/85 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSaving ? "Saving…" : readyCount === 1 ? "Add Song" : `Add ${readyCount} Songs`}
          </button>
        </div>
      </div>
    </div>
  );
}
